// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3_uWe","productName":"Table_productName__1D3v1"};